import './calendar-tools.component.scoped.sass';
import React from 'react';
import { TableToolsProps } from '../../types/table-tools-props';

export const CalendarToolsComponent = (props: TableToolsProps) => {
    return (
        <div>
        </div> 
    )
}